<template>
  <div class="index">
    <div class="tap-bar">
      <div :class="['tap', tap !== 0 || 'pitchOn']" @click="$router.push('/day')"><span>汇总</span></div>
      <div :class="['tap', tap !== 1 || 'pitchOn']" @click="$router.push('/day-gz')"><span>广州</span></div>
      <div :class="['tap', tap !== 2 || 'pitchOn']" @click="$router.push('/day-sh')"><span>上海</span></div>
      <div :class="['tap', tap !== 3 || 'pitchOn']" @click="$router.push('/day-bj')"><span>北京</span></div>
    </div>

    <div class="seek">
      <div class="date-box" @click="show = true">
        <van-icon name="clock-o"/>
        <span class="time">{{date1}}</span>
      </div>
      <p>单位：千元</p>
    </div>

    <div class="content" ref="tableContent">
      <table-tap
        :data="table.data"
        :header="table.header"
        :height="table.height"
        :width="table.width"
      >
      </table-tap>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '280px' }"
    >
      <van-datetime-picker
        v-model="date"
        type="date"
        @confirm="confirmOk"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
  import {day} from '../../api/v1'
  import {getTimes, upOfDown} from '../../utils'
  import tableTap from '@/components/table/index'

  export default {
    name: "index",
    data() {
      return {
        tap: 1,
        table: {
          header: [],
          data: [],
          width: 0,
          height: 500
        },
        date: null,
        show: false,
        date1: ''
      }
    },
    created() {
      this.date = new Date(getTimes('Y-M-D-1'))
      this.date1 = getTimes('Y-M-D-1')
      this.getList()
    },
    methods: {
      getList() {
        day.getDayList({
          date: getTimes('Y-M-D', this.date)
        }).then(res => {
          if (res.code === 200) {
            let list = res.data
            let title = list.title.zn.map((item, i) => {
              let key = list['title']['en'][i]
              let obj = {
                title: item,
                key: key,
                width: 80
              }
              if (item.includes('同比增长')) {
                obj.render = (h, p) => {
                  let text = p.row[key]
                  return h('div', {class: 'td-down-of-up'}, [
                    h('span', text),
                    h('i', {class: upOfDown(text)})
                  ])
                }
              }
              let fixed = ['渠道', '统计店铺']
              if (fixed.includes(item)) {
                obj.fixed = 'left'
              }
              return obj
            })
            this.table.header = title
            this.table.data = list['data'].filter(item => item.business_unit === '广州').map(item => item.business_unit_data)[0]
          }
        })
      },
      getTableContentSize() {
        this.table.width = this.$refs.tableContent.offsetWidth
        this.table.height = this.$refs.tableContent.offsetHeight
      },
      confirmOk(e) {
        this.date = e
        this.date1 = getTimes('Y-M-D', e)
        this.show = false
        this.getList()
      }
    },
    components: {
      tableTap
    },
    computed: {},
    mounted() {
      this.$nextTick(() => {
        this.getTableContentSize()
      })
    }
  }
</script>

<style lang="scss" scoped>
  .index {
    .tap-bar {
      padding: 10px 10px 0;
      display: flex;

      .tap {
        width: 97px;
        height: 27px;
        background: url('~@/assets/imgs/tap15@2x.png') no-repeat;
        background-size: 100% 100%;
        font-size: 15px;
        color: #fff;
        text-align: center;
        line-height: 27px;
        padding-right: 10px;

        &.pitchOn {
          background: url('~@/assets/imgs/onTap15@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
</style>
